"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emotionTheming = require("emotion-theming");

var s = _interopRequireWildcard(require("./UserActivity.style"));

var _TooltipPopup = _interopRequireDefault(require("../TooltipPopup/TooltipPopup"));

var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var displayDays = dayNames.map(function (day) {
  return day[0];
});

function getCalendarData(startingDate, endingDate, activity) {
  var currentYear = startingDate.getFullYear();
  var startingMonthIndex = startingDate.getMonth();
  var oneDay = 24 * 60 * 60 * 1000;
  var daysInMonth = Math.round(Math.abs((endingDate.getTime() - startingDate.getTime()) / oneDay));
  var startingDayIndex = startingDate.getDay();
  var startingDay = dayNames[startingDayIndex];
  return {
    currentYear: currentYear,
    startingMonthIndex: startingMonthIndex,
    daysInMonth: daysInMonth,
    startingDayIndex: startingDayIndex,
    startingDay: startingDay,
    activity: activity,
    startingDate: startingDate
  };
}

function renderGetDays(calendarData, theme, mode) {
  var daysArr = [];
  var totalDisplayedDays = 0;
  var singleRowData = [];
  var totalDayBoxes = calendarData.daysInMonth + calendarData.startingDayIndex;

  for (var i = 0; i <= totalDayBoxes; i += 1) {
    if (i !== 0 && i % 7 === 0 || i === totalDayBoxes) {
      daysArr.push(_react.default.createElement("tr", {
        key: i
      }, singleRowData));
      singleRowData = [];
    }

    if (i >= calendarData.startingDayIndex) {
      var currentDate = new Date(new Date().setDate(calendarData.startingDate.getDate() + totalDisplayedDays));
      var currentYear = currentDate.getFullYear();
      var currentDay = currentDate.getDate();
      var currentMonthIndex = currentDate.getMonth() - 1;
      var currentMonth = monthNames[currentMonthIndex > -1 ? currentMonthIndex : 11].substr(0, 3);
      var tooltipText = "".concat(currentDay, " ").concat(currentMonth, ", ").concat(currentYear);
      var active = 'false';

      if (calendarData.activity[totalDisplayedDays + 1] === 1) {
        active = 'true';
      }

      singleRowData.push(_react.default.createElement("td", {
        className: s.singleDayStyle({
          fake: false,
          active: active,
          theme: theme,
          mode: mode
        }),
        key: i
      }, _react.default.createElement(_TooltipPopup.default, {
        title: tooltipText
      }, _react.default.createElement("div", {
        className: s.fakeTooltip
      }))));
      totalDisplayedDays += 1;
    } else {
      singleRowData.push(_react.default.createElement("td", {
        fake: "true",
        className: s.singleDayStyle({
          fake: 'true',
          active: null,
          theme: theme
        }),
        key: i
      }));
    }
  }

  return daysArr;
}

var UserActivity = function UserActivity(props) {
  var startingDate = props.startingDate;
  var endingDate = props.endingDate;
  var activity = props.activity;
  var calendarData = getCalendarData(startingDate, endingDate, activity);
  var theme = props.theme;
  var mode = props.mode;
  var currentDay = startingDate.getDate();
  var currentMonth = monthNames[startingDate.getMonth()].substr(0, 3);
  var endDay = endingDate.getDate();
  var endMonth = monthNames[endingDate.getMonth()].substr(0, 3);
  var displayDay = "".concat(currentDay, " ").concat(currentMonth, " - ").concat(endDay, " ").concat(endMonth);
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(s.userActivityView(theme), props.className)
  }, _react.default.createElement("div", {
    className: s.userActivityHeader(theme)
  }, _react.default.createElement("span", {
    className: s.lastDaysStyle(theme, mode)
  }, "Last ", calendarData.daysInMonth, " days"), _react.default.createElement("span", {
    className: s.monthYearStyle(theme, mode)
  }, "(", displayDay, ")")), _react.default.createElement("table", null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, displayDays.map(function (day, i) {
    var key = i + 1;
    return _react.default.createElement("td", {
      className: s.daysStyle(theme, mode),
      key: key
    }, day);
  }))), _react.default.createElement("tbody", null, renderGetDays(calendarData, theme, mode))));
};

UserActivity.defaultProps = {
  startingDate: new Date(new Date().setDate(new Date().getDate() - 30)),
  endingDate: new Date(),
  activity: {},
  className: '',
  mode: 'light'
};
UserActivity.propTypes = {
  startingDate: _propTypes.default.instanceOf(Date),
  endingDate: _propTypes.default.instanceOf(Date),
  activity: _propTypes.default.objectOf(_propTypes.default.number),
  className: _propTypes.default.string,
  mode: _propTypes.default.oneOf(['dark', 'light'])
};

var _default = (0, _emotionTheming.withTheme)(UserActivity);

exports.default = _default;